import React, { useEffect, useRef, useState } from "react";

interface ProgressBarProps {
    interval: number;
    intervalUpdate: boolean;
    setIntervalUpdate: (value: boolean) => void;
    runInterval: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ interval, intervalUpdate, setIntervalUpdate, runInterval }) => {
    const updatePeriod = interval * 1000;
    const updateInterval = 37.5;
    const totalIntervals = updatePeriod / updateInterval; // 400 intervals
    const progressIncrement = 100 / totalIntervals; // 0.25% per interval
    const progressInterval = useRef<NodeJS.Timeout | null>(null);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (progress >= 100) {
            setIntervalUpdate(true);
        }
    }, [progress]);

    useEffect(() => {
        if (intervalUpdate) {
            setIntervalUpdate(false);
        }
    }, [intervalUpdate]);

    const startInterval = () => {
        progressInterval.current = setInterval(() => {
            setProgress((prevProgress) => (prevProgress >= 100 ? progressIncrement : prevProgress + progressIncrement));
        }, updateInterval);
    };

    const stopInterval = () => {
        setProgress(0);
        if (progressInterval.current) {
            clearInterval(progressInterval.current as NodeJS.Timeout);
        }
    };

    useEffect(() => {
        if (!runInterval) {
            stopInterval();
        } else {
            startInterval();
        }
        return () => {
            if (progressInterval.current) {
                clearInterval(progressInterval.current as NodeJS.Timeout);
            }
            stopInterval();
        };
    }, [runInterval]);

    return (
        <div className="absolute bottom-0 left-0 w-full flex flex-row h-1 bg-transparent">
            <div className="flowing-gradient h-1 animate-gradient-to-r" style={{ width: `${progress}%` }}></div>
        </div>
    );
};

export default ProgressBar;
